import { PLACE_TYPE_META, PlaceType } from "~/lib/api";
import { PlaceTypeIcon } from "~/components/ui/icons/place-type-icons";
import { IconBadge } from "~/components/ui/icon-badge";
import { Card } from "~/components/ui/card";
import { Button } from "~/components/ui/button";
import { Icon } from "~/components/ui/icons/icon";

interface PlaceTypePickerProps {
  onSelect: (type: PlaceType) => void;
  onClose?: () => void;
}

const PLACE_TYPES = Object.entries(PLACE_TYPE_META) as [PlaceType, { label: string }][];

/**
 * Place type picker displayed in map popups.
 */
export function PlaceTypePicker({ onSelect, onClose }: PlaceTypePickerProps) {
  return (
    <Card elevation={2} className="p-2 min-w-48">
      <div className="flex items-center justify-between px-2 py-1.5">
        <span className="text-sm font-medium text-muted-foreground">Add a place</span>
        {onClose && (
          <Button variant="ghost" size="icon-sm" onClick={onClose} className="-mr-1.5">
            <Icon i="close" className="size-4" />
          </Button>
        )}
      </div>
      <div className="space-y-0.5 max-h-48 md:max-h-72 overflow-y-auto">
        {PLACE_TYPES.map(([type, { label }]) => (
          <button
            key={type}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(type);
            }}
            className="w-full flex items-center gap-3 px-2 py-1.5 rounded-md text-sm hover:bg-accent transition-colors text-left cursor-pointer"
          >
            <IconBadge>
              <PlaceTypeIcon type={type} className="size-4" />
            </IconBadge>
            {label}
          </button>
        ))}
      </div>
    </Card>
  );
}
